<template>
    <div>
        <compra-direta-ferramenta-de-busca  v-model="filtrosBuscaAvancada"
                                            :situacoesPossiveis="situacoesCompraDireta"
                                            :placeholderPesquisa="placeholderPesquisa"
                                            :filtros="filtrosInterno"
                                            @eventoBuscaSimples="tratarEventoBuscaSimples"
                                            @eventoRemoverFiltro="tratarEventoRemoverFiltro"
                                            @eventoBuscaAvancada="processarEventoBuscarAvancada"
                                            @updateSituacoes="(situacoes) => filtrosBuscaAvancada.situacoes = situacoes">
        </compra-direta-ferramenta-de-busca>

        <todas-compras-diretas-tabela :itens="itens"
                                      :paginas="paginas"
                                      :total-itens="totalItens"
                                      :paginacao="$store.state.comprador.resultadoBuscaTodasComprasDiretas.paginacao"
                                      @paginar="tratarEventoPaginar"
                                      @acessar="tratarEventoAcessar"
                                      @acessarPncp="acessarPncp"
                                      @excluir="processarEventoExcluirCompra"
                                      @repetirCompra="tratarEventoRepetir" />

        <mensagem-confirmacao :exibirMensagem="mostrarDialogExclusao"
                              textoSecundario="Deseja realmente excluir a compra direta?"
                              @confirmado="excluirCompra"
                              @recusado="fecharModalConfirmacaoExclusao"/>
    </div>
</template>

<script>
import _ from 'lodash'
import azAuth from '@azinformatica/loki/src/utils/az-auth'
import {actionTypes, mutationTypes} from '@/core/constants'
import TodasComprasDiretasTabela from './TodasComprasDiretasTabela'
import CompraDiretaFerramentaDeBusca from '@/views/pages/commons/busca-avancada/CompraDiretaFerramentaDeBusca'

export default {
    name: 'TodasComprasDiretas',
    components: {
        CompraDiretaFerramentaDeBusca,
        TodasComprasDiretasTabela
    },
    data() {
        return {
            filtrosInterno: this.getFiltrosComprador(),
            filtrosBuscaAvancada: this.getFiltrosBuscaAvancada(),
            itens: [],
            paginas: 0,
            totalItens: 0,
            idItemParaDeletar: null,
            ehBuscaAvancada: false,
            mostrarDialogExclusao: false,
            compraDiretaId: null
        }
    },
    computed: {
        placeholderPesquisa() {
            const texto = this.$t('main.comprador_todas_compras_diretas_orgao.text').toLowerCase()
            return `Busque por: nº processo, nº consulta, objeto ou ${texto}`
        }
    },
    methods: {
        async buscar() {
            this.$store.commit(mutationTypes.COMPRADOR.SET_FILTROS_BUSCA_TODAS_COMPRAS_DIRETAS, this.getFiltrosInterno())
            this.setMensagemLoading('Carregando compras diretas...')
            const resultado = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_TODAS_COMPRAS_DIRETAS)
            this.itens = resultado.itemList
            this.paginas = resultado.totalPages
            this.totalItens = resultado.totalElements

            this.resetFiltroBuscaAvancada()
        },
        tratarEventoPaginar(paginacao) {
            if(this.ehBuscaAvancada) {
                this.$store.commit(mutationTypes.COMPRADOR.SET_PAGINACAO_BUSCA_AVANCADA_COMPRAS_DIRETAS_COMPRADOR, paginacao)
                this.processarEventoBuscarAvancada()
            } else {
                this.$store.commit(mutationTypes.COMPRADOR.SET_PAGINACAO_BUSCA_TODAS_COMPRAS_DIRETAS, paginacao)
                this.buscar()
            }
        },
        tratarEventoBuscaSimples(valor) {
            if (valor) {
                this.filtrosInterno.conteudo = valor
                this.filtrosInterno.objeto.value = valor
                this.buscar()
            }
        },
        tratarEventoRemoverFiltro(propriedade) {
            if (this.filtrosInterno && this.filtrosInterno.hasOwnProperty(propriedade)) {
                this.filtrosInterno[propriedade].value = this.filtrosInterno[propriedade].default
            }
            this.filtrosInterno.conteudo = ''
            this.resetFiltroBuscaAvancada()
            this.filtrosBuscaAvancada = this.getFiltrosBuscaAvancada()
            this.buscar()
        },
        tratarEventoAcessar(item) {
            const id = item.id
            this.$store.commit(mutationTypes.SET_ROTA_ORIGEM, 'TodasComprasDiretas')
            if (azAuth(this.$store.state.loki.user  .authorities, ['Comprador.Normal', 'Comprador.Admin', 'Comprador.Autoridade.Superior'])
                && (item.situacao === 'EM_ELABORACAO' || (item.situacao === 'SUSPENSA' && item.suspensaoPosAnalise === false))) {
                this.$router.push({name: 'DadosGeraisEdicao', params: {id}})
            } else {
                this.$router.push({name: 'DadosGeraisVisualizacao', params: {id}})
            }
        },
        async tratarEventoRepetir(resumoCompraDireta) {
            const processoId = resumoCompraDireta.processo
            let response
            this.habilitarLoadingGlobal()
            this.setMensagemLoading('Repetindo Compra Direta...')
            try {
                response = await this.$store.dispatch(actionTypes.IMPORTAR_PROCESSO, {processo: processoId, orgao: resumoCompraDireta.orgao})
                this.mostrarNotificacaoSucesso('Compra Direta repetida com sucesso.')
                this.tratarEventoAcessar(response)
            } catch (e) {
                this.desabilitarLoadingGlobal()
                this.mostrarNotificacaoErro(e.message)
            }
        },
        async excluirCompra() {
            if(this.compraDiretaId) {
                await this.$store.dispatch(actionTypes.REMOVER_COMPRA_DIRETA, { compraDiretaId: this.compraDiretaId, removerNaOrigem: true })
                this.mostrarNotificacaoSucesso('Compra direta excluída com sucesso.')
                const index = this.itens.findIndex(compra => compra.id === this.compraDiretaId)
                this.itens.splice(index, 1)
                this.fecharModalConfirmacaoExclusao()
            }else{
                this.mostrarNotificacaoErro('Não foi possível excluir a compra direta. Detalhes (O identificador da compra direta está nulo).')
            }
        },
        fecharModalConfirmacaoExclusao(){
            this.mostrarDialogExclusao = false
            this.compraDiretaId = null
        },
        async processarEventoExcluirCompra(compraDiretaId) {
            this.compraDiretaId = compraDiretaId
            this.mostrarDialogExclusao = true
        },
        getFiltrosComprador() {
            return _.cloneDeep(this.$store.state.comprador.resultadoBuscaTodasComprasDiretas.filtros)
        },
        getFiltrosInterno() {
            return _.cloneDeep(this.filtrosInterno)
        },
        async acessarPncp({cnpjOrgaoSuperiorPncp, ano, sequencialCompraPublica, urlFrontendPncp}) {
            await this.$store.dispatch(actionTypes.EXIBIR_NO_PNCP, {cnpjOrgaoSuperiorPncp, ano, sequencialCompraPublica, urlFrontendPncp})
        },
        getFiltrosBuscaAvancada() {
            return _.cloneDeep(this.$store.state.comprador.resultadoBuscaAvancadaComprasDiretas.filtros)
        },
        resetFiltroBuscaAvancada(){
            this.ehBuscaAvancada = false
            this.$store.state.comprador.resultadoBuscaAvancadaComprasDiretas.reset()
            /**
             * TODO Refatorar o funcionamento da busca avançada para se usar o esquema da busca simples
             *  e depois remove essas linhas abaixo, e também o atributo ehBuscaAvancada
             */

            const paginacaoInicial = {
                page: 1,
                rowsPerPage: 10,
                descending: true,
                sortBy: 'dataHoraEncerramento'
            }
            this.$store.commit(mutationTypes.COMPRADOR.SET_PAGINACAO_BUSCA_TODAS_COMPRAS_DIRETAS, paginacaoInicial)
            this.$store.commit(mutationTypes.COMPRADOR.SET_PAGINACAO_BUSCA_AVANCADA_COMPRAS_DIRETAS_COMPRADOR, paginacaoInicial)
        },
        async processarEventoBuscarAvancada() {
            this.$store.commit(mutationTypes.COMPRADOR.SET_FILTROS_BUSCA_AVANCADA_COMPRAS_DIRETAS_COMPRADOR, this.filtrosBuscaAvancada)
            this.setMensagemLoading('Carregando compras diretas...')
            const resultado = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_AVANCADA_COMPRAS_DIRETAS_COMPRADOR)
            this.itens = resultado.itemList
            this.paginas = resultado.totalPages
            this.totalItens = resultado.totalElements

            this.ehBuscaAvancada = true
        }
    }
}
</script>
